export default "__VITE_ASSET__DMOx3Qpk__"